import { Stack, Typography } from "@mui/material";
import { CoreInfoIcon } from "../../core";
import styles from "./face-verification-error-banner.module.css";
import i18nPackage from "../../i18n/i18n";
import type { VerityApiClient } from "@verity/api-client";

type CompareFacesResponse = Awaited<ReturnType<VerityApiClient["faceVerification"]["compareFaces"]>>;

type FaceVerificationError = CompareFacesResponse["errors"][number];

type FaceVerificationErrorBannerProps = {
	errors: FaceVerificationError[];
};

function getFaceVerificationErrorMessage(error: FaceVerificationError): string {
	switch (error.type) {
		case "phoneInFace":
		case "phoneInId":
		case "phoneDetected":
			return i18nPackage.t("beforeQuiz.verifyIdentity.reviewPhoto.flags.generalPhone");

		case "noIdInId":
			return i18nPackage.t("beforeQuiz.verifyIdentity.reviewPhoto.flags.missingIdCard");
		case "manyIdInId":
			return i18nPackage.t("beforeQuiz.verifyIdentity.reviewPhoto.flags.multipleIdCards");
		case "idInFace":
			return i18nPackage.t("beforeQuiz.verifyIdentity.reviewPhoto.flags.idCardInFace");

		case "missingFace":
			return i18nPackage.t("beforeQuiz.verifyIdentity.reviewPhoto.flags.missingFace");

		default:
			return "";
	}
}

export default function FaceVerificationErrorBanner({ errors }: FaceVerificationErrorBannerProps) {
	const messages = errors.map(getFaceVerificationErrorMessage).filter((msg) => msg);
	if (messages.length === 0) return null;

	return (
		<div className={styles.banner} role="alert" aria-live="polite">
			<Stack gap="10px" direction="row" alignItems="flex-start">
				<CoreInfoIcon width={18} height={18} color="#9086D3" />
				<div>
					<Typography className={styles.errorHeader}>
						{i18nPackage.t("beforeQuiz.verifyIdentity.reviewPhoto.flags.bannerTitle")}
					</Typography>
					<ul className={styles.list}>
						{messages.map((message, index) => (
							<li key={`${message}-${index}`} className={styles.listItem}>
								<Typography className={styles.text}>{message}</Typography>
							</li>
						))}
					</ul>
				</div>
			</Stack>
		</div>
	);
}
